(() => {
  const plan = (state) => {
    const eligible = state.plaqueUnits >= state.threshold;
    const updates = {};

    if (!eligible || state.hasPaidEbook) {
      state.gifts.forEach((gift) => {
        updates[gift.key] = 0;
      });
      return {
        type: Object.keys(updates).length > 0 ? 'update' : 'none',
        updates,
        removalReason: eligible ? 'paid_ebook_already_present' : 'threshold_lost',
      };
    }

    if (state.gifts.length === 0) {
      return {
        type: 'add',
        updates,
        removalReason: '',
      };
    }

    state.gifts.forEach((gift, index) => {
      if (index === 0 && gift.quantity !== 1) updates[gift.key] = 1;
      if (index > 0) updates[gift.key] = 0;
    });

    return {
      type: Object.keys(updates).length > 0 ? 'update' : 'none',
      updates,
      removalReason: '',
    };
  };

  window.PlaqueoEbookOfferCore = Object.freeze({ plan });
})();
